import r from "../managers/braze-instance.js";
import { getByteLength as er } from "../util/string-utils.js";
import { logger as E } from "../../shared-lib/index.js";
import { User } from "../User/index.js";
import { validateStandardString as ir } from "../util/validation-utils.js";
export function changeUser(e, i) {
  if (!r.rr()) return;
  if (null == e || 0 === e.length || e != e) return void E.error("changeUser requires a non-empty userId.");
  if (er(e) > User.mr) return void E.error("Rejected user id \"".concat(e, "\" because it is longer than ").concat(User.mr, " bytes."));
  if (null != i && !ir(i, "set signature for new user", "signature")) return;
  var t = r.nn();
  t && t.changeUser(e.toString(), r.lr(), i);
}